import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: number
  email: string
  fullName: string
  name?: string
  role?: string
  isPlatformAdmin?: boolean
  impersonatedBy?: string
  tenantId?: number
  tenant?: {
    id: number
    name: string
    slug: string
    plan?: string
    status?: string
    logoUrl?: string | null
    address?: string | null
    city?: string | null
    state?: string | null
    pincode?: string | null
    gstin?: string | null
    phone?: string | null
  }
  roleId?: number
  branchId?: number | null
}

export interface AuthState {
  token: string | null
  refreshToken: string | null
  user: User | null
  isLoading: boolean
  error: string | null

  setAuth: (token: string, refreshToken: string, user: User) => void
  logout: () => void
  setError: (error: string | null) => void
  setLoading: (loading: boolean) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      isLoading: false,
      error: null,

      setAuth: (token, refreshToken, user) =>
        set({
          token,
          refreshToken,
          user,
          error: null,
        }),

      logout: () =>
        set({
          token: null,
          refreshToken: null,
          user: null,
          error: null,
        }),

      setError: (error) => set({ error }),

      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
    }
  )
)
